<template>
  <skud-report-page />
</template>

<script>
import SkudReportPage from '@/views/skud/components/SkudReportPage.vue'

export default {
  name: 'ClientSkudReportPage',
  components: { SkudReportPage }
}
</script>
